export default {
  getBankAccounts(context, params) {
    const queryString = new URLSearchParams(params).toString();

    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/financial/bank-account?${queryString}`)
        .then(({ data }) => {
          context.commit("setBankAccounts", data.results);
          resolve(data);
        })
        .catch(reject);
    });
  },
  getBankAccount(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/financial/bank-account/${id}`)
        .then(({ data }) => {
          context.commit("setBankAccount", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  updateBankAccount(context, account) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`/financial/bank-account/${account.id}`, account)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  postBankAccount(context, account) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post("/financial/bank-account", account)
        .then(resolve)
        .catch(reject);
    });
  },
  deleteBankAccount(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .delete(`/financial/bank-account/${id}`)
        .then(() => {
          resolve();
        })
        .catch(reject);
    });
  },
  getBanksList(context) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get("/financial/banks")
        .then(({ data }) => {
          context.commit("setBanksList", data.results);
          resolve(data.results);
        })
        .catch(reject);
    });
  },
  getBalance(context) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get("/financial/balance")
        .then(({ data }) => {
          context.commit("setBalance", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  postWithdraw(context, info) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post("/financial/with-draw", info)
        .then(resolve)
        .catch(reject);
    });
  },

  getTransactions(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/financial/transactions?${queryString}`)
        .then(({ data }) => {
          context.commit("setTransactions", data.results);
          resolve(data);
        })
        .catch(reject);
    });
  },
  getWithdraws(context, params) {
    const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/financial/with-draw?${queryString}`)
        .then(({ data }) => {
          context.commit("setWithdraws", data.results);
          resolve(data);
        })
        .catch(reject);
    });
  },

  exportTransactions(context, props) {
    const queryString = new URLSearchParams(props).toString();
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/financial/transactions?export=true&${queryString}`)
        .then(resolve)
        .catch(reject);
    });
  },
  exportWithdraws(context, props) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get("/financial/with-draw?export=true")
        .then(resolve)
        .catch(reject);
    });
  }
};
